// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana Process Types
 * Auto-generated input/output schemas for every Rana process tag. Do not edit manually.
 *
 * The version of the OpenAPI document: generated
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { RanaFile } from "./RanaFile";
import {
  RanaFileFromJSON,
  RanaFileFromJSONTyped,
  RanaFileToJSON,
  RanaFileToJSONTyped,
} from "./RanaFile";

/**
 *
 * @export
 * @interface DelineateBasinsOutput
 */
export interface DelineateBasinsOutput {
  /**
   *
   */
  basin: RanaFile;
}

/**
 * Check if a given object implements the DelineateBasinsOutput interface.
 */
export function instanceOfDelineateBasinsOutput(value: object): value is DelineateBasinsOutput {
  if (!("basin" in value) || value["basin"] === undefined) return false;
  return true;
}

export function DelineateBasinsOutputFromJSON(json: any): DelineateBasinsOutput {
  return DelineateBasinsOutputFromJSONTyped(json, false);
}

export function DelineateBasinsOutputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): DelineateBasinsOutput {
  if (json == null) {
    return json;
  }
  return {
    basin: RanaFileFromJSON(json["basin"]),
  };
}

export function DelineateBasinsOutputToJSON(json: any): DelineateBasinsOutput {
  return DelineateBasinsOutputToJSONTyped(json, false);
}

export function DelineateBasinsOutputToJSONTyped(
  value?: DelineateBasinsOutput | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    basin: RanaFileToJSON(value["basin"]),
  };
}
